import { DC } from "../../constants";
import wordShift from "../../word-shift";

export const pelleStrikes = {
  infinity: {
    id: 1,
    requirementDescription: "Достигните Бесконечности",
    penaltyDescription: () => `Измерения Антиматерии подняты до ${formatPow(0.5, 1, 1)}`,
    rewardDescription: () => `Разблокируйте ${wordShift.wordCycle(PelleRifts.vacuum.name)}
      и навсегда получите АвтоПокупщик Бесконечности`,
    rift: () => PelleRifts.vacuum
  },
  powerGalaxies: {
    id: 2,
    requirementDescription: "Усильте Галактики",
    penaltyDescription: () => `Измерения Бесконечности подняты до ${formatPow(0.5, 1, 1)}`,
    rewardDescription: () => `Разблокируйте ${wordShift.wordCycle(PelleRifts.decay.name)}`,
    rift: () => PelleRifts.decay
  },
  eternity: {
    id: 3,
    requirementDescription: "Достигните Вечности",
    penaltyDescription: () => `Скорость Репликантов замедляется ещё быстрее после ${format(DC.E2000)}`,
    rewardDescription: () => `Разблокируйте ${wordShift.wordCycle(PelleRifts.chaos.name)}`,
    rift: () => PelleRifts.chaos
  },
  ECs: {
    id: 4,
    requirementDescription: () => `Достигните ${formatInt(115)} ВТ`,
    penaltyDescription: () => `В Вечных Челленджах, ${wordShift.wordCycle(PelleRifts.vacuum.name)}
      множитель ОБ только на ${formatPercents(0.3)} такой же сильный и ограничен до ${formatPercents(0.15)}
      от цели`,
    rewardDescription: () => `Разблокируйте ${wordShift.wordCycle(PelleRifts.recursion.name)}`,
    rift: () => PelleRifts.recursion
  },
  dilation: {
    id: 5,
    requirementDescription: "Растянутое Время",
    penaltyDescription: "Растяжение Времени постоянно активно",
    rewardDescription: () => `Храните исследование Растянутого Времени между Армагеддонами, бонус к заработку Остатков
      и разблокируйте ${wordShift.wordCycle(PelleRifts.paradox.name)}`,
    rift: () => PelleRifts.paradox
  }
};
